export const colors = {
  primary: '#10ca97',
};



// WEBPACK FOOTER //
// ./src/themes/colors.js